import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';

const validate = (values) => {
    const errors = {};

    if (!values.oldPassword) {
        errors.oldPassword = 'Vaaditaan';
    }

    if (!values.newPassword) {
        errors.newPassword = 'Vaaditaan';
    }

    if (!values.newPasswordConfirmation) {
        errors.newPasswordConfirmation = 'Vaaditaan';
    }

    if (values.newPassword !== values.newPasswordConfirmation) {
        errors.newPasswordConfirmation = 'Salasanan täytyy olla vastata vahvistusta'
    }

    return errors;
};

const renderField = ({input, label, placeholder, type, value, meta: {touched, error}}) => (
  <div className='form-group'>
    <label className='upper-label'>{label}</label>
    <input {...input} type={type} placeholder={placeholder} value={value}
      className={touched && error && 'form-control is-invalid'
           || touched && 'form-control is-valid' || 'form-control'}/>
  </div>
);

const PasswordChangeForm = props => {
  const { handleSubmit, changePassword, formStatus, translate } = props;
  const { submitted, isHandlingSubmission, successfulSubmission } = formStatus;
  const canSubmit =  isHandlingSubmission ? true : false;
  let submissionStatusIcon = '';
  let submissionStatusText = 'Vaihda salasana';
  let submissionbuttonTheme = 'btn-primary';

  if (isHandlingSubmission) {
      submissionStatusIcon = 'fa fa-spinner fa-spin';
      submissionStatusText = 'Vaihdetaan salasanaa...';
  } else if (submitted && !isHandlingSubmission && successfulSubmission) {
       submissionStatusIcon = 'fa fa-check';
       submissionStatusText = 'Vaihtaminen onnistui';
       submissionbuttonTheme = 'btn-success';
  } else if (submitted && !isHandlingSubmission && !successfulSubmission) {
      submissionStatusIcon = 'fa fa-warning';
      submissionStatusText = 'Vaihtaminen epäonnistui';
      submissionbuttonTheme = 'btn-danger';
  }


  return (
    <div className='wrapper'>
      <form className='form-reset-password' onSubmit={handleSubmit(changePassword)}>
        <h2 className='form-reset-password-header'>{translate('passwordChange.Salasanan vaihtaminen')}</h2>
        <Field name='oldPassword' label={translate('passwordChange.Nykyinen salasana')} type='password' component={renderField} placeholder={translate('passwordChange.Nykyinen salasana')}/>
        <Field name='newPassword' label={translate('passwordChange.Uusi salasana')} type='password' component={renderField} placeholder={translate('passwordChange.Uusi salasana')}/>
        <Field name='newPasswordConfirmation' label={translate('passwordChange.Toista uusi salasana')} type='password' component={renderField} placeholder={translate('passwordChange.Toista uusi salasana')}/>
        <button className={'btn btn-lg col-lg-12 ' + submissionbuttonTheme} type='submit' disabled={canSubmit}>
          <i className={submissionStatusIcon}/>
          <span className='btn-text'>{translate('passwordChange.' + submissionStatusText)}</span>
        </button>
      </form>
    </div>
  )
};

PasswordChangeForm.propTypes = {
    handleSubmit: PropTypes.func,
    fields: PropTypes.object,
    changePassword: PropTypes.func
};

export default reduxForm({
    form: 'passwordChangeForm',
    validate
})(PasswordChangeForm);



// WEBPACK FOOTER //
// ./src/components/PasswordChangeForm.js